import { formatError, login, sendMail } from '@/services/AuthService';
import { axiosGet } from '@/utils/axiosGet';

export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';

export function Logout(setUserDetails, setOriginalUserDetails) {
  axiosGet('jwt-remove-cookie').then((response) => {
    localStorage.clear();
    sessionStorage.clear();

    if (typeof setUserDetails === 'function') {
      setUserDetails(null);
    }
    if (typeof setOriginalUserDetails === 'function') {
      setOriginalUserDetails(null);
    }
  });

  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, setSentStatus) {
  return () => {
    sendMail(email);
    setSentStatus(true);
  };
}

export function loginWithToken(loginToken, navigate, setRefreshUserDetails) {
  return (dispatch) => {
    login(loginToken)
      .then((response) => {
        dispatch(loginConfirmedAction(response.data));
        setRefreshUserDetails((prev) => prev + 1);
        navigate('/nominations');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(loginFailedAction(errorMessage));
        navigate('/login');
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
